import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { TbPaperBag } from "react-icons/tb";
import { MdAddShoppingCart } from 'react-icons/md'
import { baseColour } from '../utils/colors'
import classes from '../pages/storeSelect/StoreSelect.module.css'
import styleClasses from '../components/itemComponent.module.css'
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import FaceIcon from '@mui/icons-material/Face';
import { IoFastFoodSharp } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import { addToCart } from '../state/redux/cartSlice';
import mealplanImage from "../assets/images/mp.png"


export default function ProductItem(props) {

    const dispatch = useDispatch()
    const color = props.data?.color_code || baseColour
    const handleAdd = (e) => {
        e.stopPropagation()
        dispatch(addToCart({ product_id: props.data.id, name: props.data.name, cost: props.data.price }))
    }

    return (
        <Card data-testid="product-container" onClick={handleAdd} sx={{ maxWidth: 260, height: '100%', borderRadius: 3, cursor: 'pointer', position: 'relative', overflow: 'visible', transition: 'transform 180ms ease, box-shadow 180ms ease', '&:hover': { transform: 'translateY(-6px)', boxShadow: 'rgba(0, 0, 0, 0.12) 0px 10px 30px' } }}>
            {/* Top visual area */}
            <div style={{ padding: 18, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className={styleClasses.avatarWrap} style={{ backgroundColor: color }}>
                    <img src={mealplanImage} alt={props.data.name} className={styleClasses.avatar} />
                </div>
            </div>

            {/* price pill top-right */}
            <div className={styleClasses.pricePill}>GH¢{props.data.price}</div>

            <CardContent sx={{ paddingTop: 0, paddingBottom: 1 }}>
                <Typography gutterBottom variant="subtitle1" component="div" sx={{ fontWeight: 700, textAlign: 'center', fontSize: { xs: 14, sm: 15 } }}>
                    {props.data.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {props.data.description || ''}
                </Typography>
            </CardContent>

            {/* floating add button */}
            <button className={styleClasses.fabAdd} onClick={handleAdd} aria-label="Add to cart">
                <MdAddShoppingCart style={{ color: '#fff' }} />
            </button>

        </Card>
    )
}
//boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'